"use client";

import { useState, useEffect } from "react";
import { SearchBar } from "./search-bar";

export function MobileStickySearch() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const sentinel = document.querySelector("[data-hero-searchbar]");
    if (!sentinel) return;

    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      threshold: 0,
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-0 right-0 left-0 z-50 bg-white px-4 py-2 sm:hidden">
      <SearchBar />
    </div>
  );
}
